export enum IsEvaluated {
  Yes = 'Yes',
  NotYet = 'Not yet, but an evaluation is foreseen',
  No = 'No',
  DontKnow = "Don't know"
}
